export default __webpack_public_path__ + "static/media/quizloading_background3.50950137.jpg";